import { Theater } from '@cinemark/content-api-client';

const isGamescapeTheater = (theater: Theater): boolean => {
  return !!theater.isFamilyEntertainmentCenter;
};

const formatStateCity = (state?: string, city?: string): string => {
  if (!state || !city) return '';

  const formattedState = state.toLowerCase();
  const formattedCity = city.toLowerCase().replace(/\s+/g, '-');

  return `${formattedState}-${formattedCity}`;
};

export const hasValidTheaterLocation = (theater: Theater): boolean => {
  return !!formatStateCity(theater.state, theater.city) && !!theater.slug;
};

/**
 * Generates the canonical URL path for a theater.
 * Examples:
 * - Regular: "/theatres/tx-plano/cinemark-west-plano-and-xd"
 * - Gamescape: "/gamescape/tx-plano/gamescape-theater-944-qa-pos-125x"
 */
export const getTheaterUrlPath = (theater: Theater): string => {
  const stateCity = formatStateCity(theater.state, theater.city);
  const isGamescape = isGamescapeTheater(theater);

  if (!stateCity || !theater.slug) {
    return `/theatre-${theater.theaterId}`;
  }

  const baseRoute = isGamescape ? '/gamescape' : '/theatres';

  return `${baseRoute}/${stateCity}/${theater.slug}`;
};
